import BasePaths from "../../../constants/basePaths";
import { Auth, API } from "aws-amplify";

const sendEmail = async (objProblem, props) => {
    const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
    const {
        attributes: { name: userName, family_name, email, phone_number }
    } = user;
    const { locale, hotelConfig } = props;
    const { hotelName, bundleId } = hotelConfig;
    const apiName = "WebeeAPI";
    const path = `${BasePaths.UTILITIES_BASE}/email`;
    const myInit = {
        headers: { language: locale },
        body: {
            description: "",
            details: {
                "Company Name": hotelName,
                "E-mail": email,
                "Message": objProblem?.description,
                "Name": userName,
                "Phone Number": phone_number,
                "bundleId": bundleId,
                "StaffApp Link": window.location.origin
            },
            recipients: [
                "support@getwebee.com"
            ],
            subject: `StaffApp Problem - ${userName} ${family_name} - ${objProblem?.subject} - ${Date.now()}`,
            title: `StaffApp Problem - ${userName} ${family_name} - ${objProblem?.subject} - ${Date.now()}`
        }
    };
    try {
        await API.post(apiName, path, myInit);
    } catch (error) {
        console.error("Send Problem Report Email Error: ", error);
    }
};

export default sendEmail;